import React, { useState, useEffect } from "react";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Repository from "../../../../configs/axios/repository";
import Spinner from "../../../../@core/components/spinner/Fallback-spinner";
import { Card, CardBody, Row, Col } from "reactstrap";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import {
    convertFromHTML,
    convertToRaw,
    EditorState,
    ContentState,
} from "draft-js";

import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";

const NoteDetail = (props) => {
    const history = useHistory();
    const [loadingData, setLoadingData] = useState(true);
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [isSummeryTab, setIsSummeryTab] = useState(false);
    const [isSummerized, setIsSummerized] = useState(false);
    const [originalText, setOriginalText] = useState(null);
    const [note, setNote] = useState("");
    const [summarizedText, setSummarizedText] = useState("");
    // *****
    const [editorState, setEditorState] = useState(EditorState.createEmpty());
    const [htmlText, setHtmlText] = useState("");
    // ****
    const location = useLocation();
    const role = useSelector((state) => state.layout.role);
    let note_id = location.state?.note_id;
    let course_id = location.state?.course_id;
    let courseName = location.state?.courseName;

    const onEditorStateChange = (newEditorState) => {
        setEditorState(newEditorState);
        const currentContent = newEditorState.getCurrentContent();
        const rawContentState = convertToRaw(currentContent);

        // const plainText = currentContent.getPlainText("\u0001");
        // Convert the raw content state to HTML
        const html = draftToHtml(rawContentState);
        setHtmlText(html);
        if (isSummeryTab) {
            setSummarizedText(html);
        } else {
            setNote(html);
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let modifiedText = note;

        if (Number(modifiedText.length) > Number(194582)) {
            Swal.fire({
                title: "The original note is quite long, please shorten it.",
                icon: "warning",
                confirmButtonColor: "#16285e",
            });
        } else {
            Swal.fire({
                title: "Are you sure?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, save it",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    setLoadingData(false);
                    let data = {
                        notes: modifiedText,
                        title: title,
                        summary:
                            modifiedText.length < 100
                                ? modifiedText
                                : summarizedText,
                        description: description,
                        note_id: { note_id: note_id },
                    };
                    const result = await Repository.updateData(
                        `api/notes/updateNotes/${note_id}`,
                        data
                    );
                    if (result.status === 200 || result.status === 201) {
                        if (role == "instructor") {
                            history.push({
                                pathname: `courseDetails`,
                                search: `course_id=${course_id}`,
                                state: { courseName },
                            });
                        } else {
                            history.push({
                                pathname: "/home",
                            });
                        }
                    }
                }
            });
        }
    };

    const findNotesById = async () => {
        setLoadingData(false);

        const result = await Repository.findByEndPoint(
            `api/notes/findNotesById/${note_id}`
        );

        if (result.data.success == true) {
            setNote(result.data?.data?.notes);
            setTitle(result.data?.data?.title);
            setDescription(result.data?.data?.description);
            setSummarizedText(result.data?.data?.summary);
            if (result.data?.data?.notes) {
                updateEditor(`<div>${result.data?.data?.notes}</div>`);
            }
        }
        setLoadingData(true);
    };

    useEffect(() => {
        if (note_id != undefined) {
            findNotesById();
        }
    }, [note_id]);
    const updateEditor = (htmlText) => {
        const contentStateFromHTML = convertFromHTML(htmlText);
        const contentState = ContentState.createFromBlockArray(
            contentStateFromHTML.contentBlocks,
            contentStateFromHTML.entityMap
        );

        // Create a new EditorState using the ContentState
        const initialEditorState = EditorState.createWithContent(contentState);

        // Set the new EditorState as the current editor state
        setEditorState(initialEditorState);
    };
    useEffect(() => {
        if (!isSummeryTab && note) {
            updateEditor(note);
        } else if (isSummeryTab && summarizedText) {
            updateEditor(summarizedText);
        }
    }, [isSummeryTab]);

    return loadingData ? (
        <div className="mt-4">
            <div className="d-flex justify-content-between">
                <div className="clidrenDivCompakt testH1">
                    <div className="mt-4 ">
                        <h1 className="noteTitle">Edit note</h1>
                    </div>
                </div>
            </div>
            <CardBody>
                <div>
                    <form onSubmit={handleSubmit}>
                        <Row>
                            <Col xl="12" md="12" sm="12">
                                <input
                                    value={title}
                                    className="titleNote"
                                    type="text"
                                    name="title"
                                    placeholder="Title"
                                    onChange={(e) => {
                                        setTitle(e.target.value);
                                    }}
                                />
                            </Col>
                            <Col xl="12" md="12" sm="12" className="mt-3">
                                <input
                                    value={description}
                                    className="titleNote"
                                    type="text"
                                    name="description"
                                    placeholder="Title"
                                    onChange={(e) => {
                                        setDescription(e.target.value);
                                    }}
                                />
                            </Col>
                            <Col xl="12" md="12" sm="12">
                                <div className="tabMenuCreateNote">
                                    <div className="tabs mt-3">
                                        <div
                                            className={
                                                isSummeryTab
                                                    ? " original"
                                                    : "original selectedTab"
                                            }
                                            onClick={() => {
                                                setIsSummeryTab(false);
                                            }}
                                        >
                                            Original
                                        </div>
                                        <div
                                            className={
                                                isSummeryTab
                                                    ? "selectedTab summary"
                                                    : "summary"
                                            }
                                            onClick={() => {
                                                if (note != "") {
                                                    setIsSummeryTab(true);
                                                }
                                            }}
                                        >
                                            Summary
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <span>
                                            {isSummeryTab
                                                ? summarizedText?.length
                                                : note?.length}
                                            /200000
                                        </span>
                                    </div>
                                </div>

                                <Editor
                                    editorState={editorState}
                                    onEditorStateChange={onEditorStateChange}
                                    toolbarClassName="toolbarClassName"
                                    wrapperClassName="wrapperClassName"
                                    editorClassName="editorClassName"
                                />
                            </Col>
                            <Col xl="12" md="12" sm="12">
                                <div className="testBtn mt-1 mb-4">
                                    <button
                                        onClick={() => {
                                            history.push({
                                                pathname: "/home",
                                            });
                                        }}
                                        type="button"
                                        className="btnOkTest"
                                    >
                                        Back
                                    </button>
                                    <button
                                        type="submit"
                                        className="btnNextTest"
                                    >
                                        Save note
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </form>
                </div>
            </CardBody>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default NoteDetail;
